import { enhancedApi as api } from './generated/smartyService';

/**
 * Enhanced Smarty API with blob response handling for PDF generation
 */
export const enhancedSmartyApi = api.enhanceEndpoints({
  endpoints: {
    smartyPropertyReportPdf: {
      query: (queryArg) => ({
        url: `/api/smarty/property/report-pdf/`,
        method: 'POST',
        body: queryArg.body,
        responseHandler: (response) => response.blob(),
        cache: 'no-store',
      }),
    },
  },
});

export const {
  useSmartyPropertyLookupQuery,
  useSmartyPropertyReportPdfMutation,
} = enhancedSmartyApi;

// Re-export types from generated service
export type {
  PropertyAttributes,
  PropertyDataResult,
  PropertyDataResultsResponse,
  SmartyPropertyLookupApiArg,
  SmartyPropertyLookupApiResponse,
  SmartyPropertyReportPdfApiArg,
  SmartyPropertyReportPdfApiResponse,
} from './generated/smartyService';
